export const pluginPrefix = 'PLUGIN:HP_PLUGIN:';
export const SET_PURCHASE_ORDER = `${pluginPrefix}SET_PURCHASE_ORDER`;